import { LOGO_URL } from "@/lib/api";

export default function Logo({ size = 36, withText = true, textSize = "text-2xl", textColor }) {
    return (
        <div className="inline-flex items-center gap-2.5">
            <div
                className="rounded-[10px] overflow-hidden shadow-[0_0_24px_rgba(224,26,79,0.45)] ring-1 ring-white/10"
                style={{ width: size, height: size }}
            >
                <img
                    src={LOGO_URL}
                    alt="India Reels"
                    className="w-full h-full object-cover"
                    width={size}
                    height={size}
                />
            </div>
            {withText && (
                <div className={`font-heading font-black ${textSize} leading-none tracking-tight`}>
                    <span className="gradient-text">india</span>
                    <span className={textColor || "text-white"}>reels</span>
                </div>
            )}
        </div>
    );
}
